@if ({ isLoggingIn: isLoggingIn$ | async }; as STATE) {
  <form
    class="form"
    [formGroup]="loginForm"
    (ngSubmit)="onSubmit()"
    [ngxsForm]="statePropertyPath"
  >
    <div class="form__group">
      <label for="email" class="form__label"
        >Adresse électronique
        <span class="form__label--required">*</span>
      </label>
      <div class="form__item form__item--with-prefix">
        <span class="form__prefix">
          <mat-icon svgIcon="dgi-msg" color="primary"></mat-icon>
        </span>
        <input
          type="email"
          id="email"
          formControlName="username"
          class="form__input"
          placeholder="Saisir l'adresse électronique"
        />
      </div>

      @if (username?.touched && username?.errors?.required) {
        <mat-error
          [innerHtml]="'Ce champ est requis'"
          class="form__error-red"
        ></mat-error>
      }
    </div>

    @if (
      { value: false, canShow: !loginForm.get('accessTokenId')?.value };
      as togglePassword
    ) {
      @if (togglePassword.canShow) {
        <div class="form__group">
          <label for="password" class="form__label">
            <p class="form__label--split">
              <span>
                Mot de passe
                <span class="form__label--required">*</span>
              </span>
              <span class="form__forgot">
                <a routerLink="/auth/reset-password"> </a>
              </span>
            </p>
          </label>
          <div class="form__item form__item--with-prefix">
            <span class="form__prefix">
              <mat-icon svgIcon="dgi-password" color="primary"></mat-icon>
            </span>
            <input
              #passwordInput
              type="password"
              id="password"
              class="form__input"
              formControlName="password"
              placeholder="Saisir le mot de passe"
            />
            <button
              type="button"
              mat-icon-button
              (click)="
                togglePassword.value = !togglePassword.value;
                passwordInput.type = togglePassword.value ? 'text' : 'password'
              "
              tabindex="-1"
              class="form__suffix"
              aria-label="Afficher ou masquer le mot de passe"
            >
              <mat-icon
                svgIcon="{{
                  togglePassword.value ? 'dgi-view' : 'dgi-view_off'
                }}"
              ></mat-icon>
            </button>
          </div>

          @if (password?.touched && loginForm.errors?.haveLeastOneFieldFilled) {
            <mat-error
              [innerHtml]="'Ce champ est requis'"
              class="form__error-red"
            >
            </mat-error>
          }

          @if (password?.touched && password?.errors?.minlength) {
            <mat-error
              [innerHtml]="
                'Le mot de passe doit contenir au moins 8 caractères'
              "
              class="form__error-red"
            ></mat-error>
          }
        </div>
      }
    }

    <div class="form__actions">
      <p class="form__actions--text mt-none">
        Vous avez oublié votre mot de passe ?
        <span>
          <a [routerLink]="routes.resetPassword" class="form__actions--link"
            >Réinitialiser
          </a>
        </span>
      </p>

      <button
        button
        size="lg"
        [fullWidth]="true"
        type="submit"
        [disabled]="!!STATE.isLoggingIn || loginForm.invalid"
        [loading]="!!STATE.isLoggingIn"
        loadingText="Connexion en cours..."
      >
        Se connecter
      </button>

      <p class="form__actions--text">
        Vous n'aviez pas encore de compte ?
        <span>
          <a [routerLink]="routes.signup" class="form__actions--link"
            >Créer un compte</a
          >
        </span>
      </p>

      <hr />

      <a
        [routerLink]="routes.companyPublicSearch"
        class="btn btn-outline-primary"
      >
        Vérification de facture, reçu & NCC
      </a>
    </div>
  </form>
}
